import { SvgIcon, SvgIconProps } from '@mui/material';

export const DTMicroIcon = (props: SvgIconProps) => (
  <SvgIcon
    component="svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4991 1.62581C8.88649 1.62581 7.57923 2.92996 7.57923 4.53871V10.5C7.57923 12.1088 8.88649 13.4129 10.4991 13.4129C12.1117 13.4129 13.4189 12.1088 13.4189 10.5V4.53871C13.4189 2.92996 12.1117 1.62581 10.4991 1.62581ZM5.94955 4.53871C5.94955 2.03205 7.98644 0 10.4991 0C13.0117 0 15.0486 2.03205 15.0486 4.53871V10.5C15.0486 13.0067 13.0117 15.0387 10.4991 15.0387C7.98644 15.0387 5.94955 13.0067 5.94955 10.5V4.53871Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4991 16.3935C10.9491 16.3935 11.3139 16.7575 11.3139 17.2065V20.1871C11.3139 20.6361 10.9491 21 10.4991 21C10.049 21 9.68423 20.6361 9.68423 20.1871V17.2065C9.68423 16.7575 10.049 16.3935 10.4991 16.3935Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.71912 10.438C4.16602 10.3852 4.5712 10.7038 4.62411 11.1497C4.79444 12.585 5.48672 13.9081 6.56973 14.8682C7.65274 15.8283 9.05119 16.3586 10.5 16.3586C11.9488 16.3586 13.3473 15.8283 14.4303 14.8682C15.5133 13.9081 16.2056 12.585 16.3759 11.1497C16.4288 10.7038 16.834 10.3852 17.2809 10.438C17.7278 10.4908 18.0472 10.895 17.9943 11.3408C17.777 13.1715 16.8941 14.859 15.5128 16.0835C14.1315 17.308 12.3478 17.9844 10.5 17.9844C8.65215 17.9844 6.86853 17.308 5.48723 16.0835C4.10593 14.859 3.22297 13.1715 3.00573 11.3408C2.95282 10.895 3.27222 10.4908 3.71912 10.438Z"
    />
  </SvgIcon>
);
